import React, { useEffect, useRef, useState } from "react";
import {
  getNewsletters,
  getNewsletter,
  setNewsletter,
  deleteNewsletter,
  getNewsletterCount,
} from "../../services/address-book";
import Lists from "../../modules/hcmd/components/Lists";
import { useParams } from "react-router-dom";
import Forms from "../../modules/hcmd/components/Forms";
import { usePermission } from "../../services/auth";
import moment from "moment/moment";
import Box from "@mui/material/Box";

NewsletterHcs.propTypes = {};

function NewsletterHcs(props) {
  let { id } = props;

  const [isForm, setIsForm] = useState(false);
  const [filter, setFilter] = useState("");
  const [listFilter, setListFilter] = useState({ type: 10 });

  const permissions = usePermission("dictionary");

  const params = useParams();
  if (!id && !isNaN(parseInt(params.id)) && parseInt(params.id) >= 0) {
    id = parseInt(params.id);
    if (!isForm) {
      setIsForm(true);
    }
  } else if (!isNaN(parseInt(id)) && parseInt(id) >= 0 && !isForm) {
    setIsForm(true);
  } else if (isForm) {
    setIsForm(false);
  }

  // ide jonnek a tipusnal hasznalt egyeb adatok deklaralasa
  const frequencies = [
    {
      id: 10,
      value: "heti",
      name: "heti",
    },
    {
      id: 20,
      value: "napi",
      name: "napi",
    },
  ];

  // ide jon az oszlopok deklaralasa
  const columns = [
    {
      field: "id",
      fieldType: "number",
      hide: true,
    },
    {
      field: "name",
      fieldType: "text",
      headerName: "Név",
      validation: {
        required: true,
        minLength: 3,
      },
    },
    {
      field: "email",
      fieldType: "text",
      headerName: "E-mail",
      validation: {
        required: true,
        minLength: 3,
      },
    },
    {
      field: "frequency",
      fieldType: "select",
      headerName: "Gyakoriság",
      valueGetter: (params) => {
        let v = "egyéb";
        switch (params.row.frequency) {
          case 10:
            v = "heti";
            break;
          case 20:
            v = "napi";
            break;
        }
        return v;
      },
    },
    {
      field: "createTime",
      fieldType: "",
      headerName: "Módosítás / Létrehozás",
      valueGetter: (params) => {
        let v = "";
        if (
          params.row.updateTime &&
          params.row.createTime !== params.row.updateTime
        ) {
          v +=
            moment(params.row.updateTime).format("YYYY-MM-DD HH:mm:ss") + " / ";
        }
        v += moment(params.row.createTime).format("YYYY-MM-DD HH:mm:ss");
        return v;
      },
      renderCell: (params) => {
        const createTime = moment(params.row.createTime).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        let updateTime = "";
        if (
          params.row.updateTime &&
          params.row.createTime !== params.row.updateTime
        ) {
          updateTime = moment(params.row.updateTime).format(
            "YYYY-MM-DD HH:mm:ss"
          );
        }
        return (
          <Box sx={{ textAlign: "center" }}>
            {updateTime}
            <br />
            {createTime}
          </Box>
        );
      },
    },
    {
      field: "isActive",
      fieldType: "boolean",
      defaultValue: true,
      headerName: "Státusz",
      width: 100,
      valueGetter: (params) => {
        if (params.row.filter === "bounced") {
          return "visszapattant";
        } else {
          return params.row.isActive ? "aktív" : "inaktív";
        }
      },
      submitTransform: (value) => {
        return value ? 1 : 0;
      },
    },
    {
      field: "userId",
      fieldType: "",
      headerName: "Felhasználó ID",
      width: 100,
    },
  ];

  // ide jon a fejlec deklaralasa
  const header = {
    title: "Állásposta feliratkozottak (HC)",
    url: "/address-books/newsletter-hcs",
    item: "állásposta feliratkozott",
  };

  const refTimeout = useRef(null);

  const handleQuickfilter = (value) => {
    if (refTimeout.current) {
      clearTimeout(refTimeout.current);
      refTimeout.current = null;
    }
    refTimeout.current = setTimeout(() => {
      setFilter(value);
    }, 100);
  };

  useEffect(() => {
    let where = {};
    if (filter.toString() !== "") {
      const like = `%${filter}%`;
      where.and = [
        { type: 10 },
        { or: [{ name: { like: like } }, { email: { like: like } }] },
      ];
    } else {
      where = { type: 10 };
    }
    setListFilter(where);
  }, [filter]);

  return (
    <>
      {isForm && (
        <Forms
          editable={true}
          id={id}
          header={header}
          permissions={permissions}
          columns={columns}
          getFunc={getNewsletter}
          getParams={{ type: 10 }}
          setFunc={setNewsletter}
          frequencies={frequencies}
        ></Forms>
      )}
      {!isForm && (
        <Lists
          header={header}
          permissions={permissions}
          getFunc={getNewsletters}
          getCountFunc={getNewsletterCount}
          quickfilterFunc={handleQuickfilter}
          getParams={listFilter}
          deleteFunc={deleteNewsletter}
          columns={columns}
          frequencies={frequencies}
        ></Lists>
      )}
    </>
  );
}

export default NewsletterHcs;
